module.exports = __webpack_public_path__ + "static/media/CS2 -- 6.4299c0d6.png";